<template>
  <rect opacity="0.5" y="7" width="4" height="9" rx="1" fill="#3769D6" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 3.74441C6 3.3028 6.28967 2.91347 6.71265 2.78658L14.7127 0.386579C15.3543 0.194096 16 0.674543 16 1.34441V15.0004C16 15.5527 15.5523 16.0004 15 16.0004H7C6.44772 16.0004 6 15.5527 6 15.0004V3.74441ZM8 11.5005C8 11.2243 8.22386 11.0005 8.5 11.0005H13.5C13.7761 11.0005 14 11.2243 14 11.5005V12.5005C14 12.7766 13.7761 13.0005 13.5 13.0005H8.5C8.22386 13.0005 8 12.7766 8 12.5005V11.5005ZM8.5 7.00049C8.22386 7.00049 8 7.22435 8 7.50049V8.50049C8 8.77663 8.22386 9.00049 8.5 9.00049H13.5C13.7761 9.00049 14 8.77663 14 8.50049V7.50049C14 7.22435 13.7761 7.00049 13.5 7.00049H8.5Z"
    fill="#3769D6"
  />
</template>
